<ngx-spinner type="ball-spin" size="medium" color="rgba(34,193,176,0.88)" bdColor="rgba(255,255,255,0.25)" [fullScreen]="true"></ngx-spinner>
<router-outlet></router-outlet>